import { render, staticRenderFns } from "./Bmat.vue?vue&type=template&id=35c9681d"
import script from "./Bmat.vue?vue&type=script&lang=js"
export * from "./Bmat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports